import { render } from "./UserBibliography.vue?vue&type=template&id=93ab63a2"
import script from "./UserBibliography.vue?vue&type=script&lang=js"
export * from "./UserBibliography.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__